import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { MathJaxContext } from "better-react-mathjax";
import '../styles/bizofficer.css';
import '../styles/build/mathquill.css';

const config = {
	loader: { load: ["input/mml", "output/chtml"] },
	mml: {}
};


const CustomizedDialogs = React.forwardRef((props, ref) => {  

	var counterMRMT = 0, counterMCMT = 0;
	const alphaArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

	function mrmtCorrectAnswer(){
		let ans = "";
		if(props?.question?.responseChoice){
			for(let i=0; i<props?.question?.responseChoice.length; i++){
				if(props?.question?.correctResponse.indexOf(props?.question?.responseChoice[i].responseId)>-1){
					ans += props?.question?.responseChoice[i].responseText;
					ans +=", ";
				}
			}
		}
		return ans;
	}

return (
    <>
							<Box >
								<Grid container spacing={2} >
									<Grid item md={12} xs={12} className="questionBox" >										
										{(props?.question?.commonDataDescription && props?.question?.commonDataDescription.length > 0) ? <div className="preWrap animate-zoom" >
											{
												<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: props?.question?.commonDataDescription.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
											}
										</div> : null}
										
										{(props?.question?.questionBody && props?.question?.questionBody.length > 0) ?
										<div className="preWrap animate-zoom" >
											<span className="questionNum" ><b style={{color:'#0000FF'}}>Question {props.num?props.num:null}: </b></span>
											<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: props?.question?.questionBody.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
										</div>
										:null}

										{
											props?.question?.columns ?
												<div className="animate-zoom">
													<table width="100%">
														<tr>
															{
																props?.question?.columns?.map((myRow, index) => (
																	<td className="btmbdrgry pdlft10"><h3>{myRow.columnHeader}</h3></td>
																))
															}
														</tr>
														<tr>
															{props?.question?.columns?.map((myCol, indexCol) => (
																<td><table width="100%">{
																	myCol.columnRows?.map((myRow, indexrrr) => (
																		<tr>
																			<td key={'crwq' + indexrrr + 'dd' + indexCol} className="btmbdrgry pdlft10 content-justify preWrap" >
																				{myRow.rowId}.&nbsp;
																				{(myRow.rowName && myRow.rowName.length > 0) ?
																					<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.rowName.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
																					: null
																				}
																			</td>
																		</tr>
																	))
																}</table>
																</td>
															))}
														</tr>
													</table>
												</div>
												: null
										}
										<div className="answerBox animate-zoom" >											
											{
												(props?.question?.questionType && props?.question?.questionType.indexOf("Subjective") > -1) ?
												    <Box >
														 {
															props?.question?.responseChoice?.map((myRow, index) => (
																<p key={'qkey' + index} id={'qmrid' + index}  >
																	<span className="inputLable" style={{ marginRight: 10, fontWeight: 'normal' }}>{alphaArr[index]}.</span>
																	<span className="inputLable content-justify preWrap" >
																		<label for={"ans" + props?.question?.questionId + "a" + index} >
																			{(myRow.responseText && myRow.responseText.length > 0) ?<>
																				<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.responseText.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
																				<br/>Marks: {myRow.partMarks}
																				</>: null
																			}
																		</label>
																	</span>
																</p>
															))
														 }		
													</Box>
													: props?.question?.questionType == 'Matching Type' ?
														<table><span hidden>{counterMRMT = 0}</span>
															<tr><th className="mrmtcol" ></th>{props?.question?.columns[1]?.columnRows?.map((myRow, index) => (<th key={'mrmatch' + index} className="mrmtcol" >{myRow.rowId}</th>))}</tr>
															{props?.question?.columns[0]?.columnRows?.map((myRowLeft, indexLeft) => (
																<tr key={'trmmt' + indexLeft} ><th className="mrmtcol" >{myRowLeft.rowId}</th>{props?.question?.columns[1]?.columnRows?.map((myRowRight, indexRight) => (<td key={'mrmtchkb' + indexRight} className="mrmtcol" ><input type="radio" id={"ans" + props?.question?.questionId + "a" + (counterMCMT = counterMCMT + 1)} value={alphaArr[counterMRMT - 1]} name={"ans" + props?.question?.questionId + 'tr' + indexLeft} className="inputRadio" checked={props?.question?.correctResponse.indexOf(alphaArr[counterMRMT - 1])>-1?true:false} /></td>))}</tr>
															))}
														</table>
														: props?.question?.questionType == 'MR Matching Type' ?<>
															<table><span hidden>{counterMRMT = 0}</span>
																<tr><th className="mrmtcol" ></th>{props?.question?.columns[1]?.columnRows?.map((myRow, index) => (<th key={'mrmatch' + index} className="mrmtcol" >{myRow.rowId}</th>))}</tr>
																{props?.question?.columns[0]?.columnRows?.map((myRowLeft, indexLeft) => (
																	<tr key={'trmmt' + indexLeft} ><th className="mrmtcol" >{myRowLeft.rowId}</th>{props?.question?.columns[1]?.columnRows?.map((myRowRight, indexRight) => (<td key={'mrmtchkb' + indexRight} className="mrmtcol" ><input type="checkbox" id={"ans" + props?.question?.questionId + "a" + (counterMRMT = counterMRMT + 1)} value={alphaArr[counterMRMT - 1]} className="inputRadio" checked={props?.question?.correctResponse.indexOf(alphaArr[counterMRMT - 1])>-1?true:false} /></td>))}</tr>
																))}
															</table>
															{props?.question?.correctResponse?
															<p>
																<b style={{color:'#0000FF'}} >Correct Answer:</b> {mrmtCorrectAnswer()}
															</p>
															:null}
															</>: props?.question?.questionType == 'Multiple Response' ?
                              									props?.question?.responseChoice?.map((myRow, index) => (
																	<p key={'qkey' + index} id={'qmrid' + index} >
																		<span className="inputSpan" ><input type="checkbox" id={"ans" + props?.question?.questionId + "a" + index} value={myRow.responseId} className="inputRadio" checked={props?.question?.correctResponse.indexOf(myRow.responseId)>-1?true:false} /></span>
																		<span className="inputLable" style={{ marginRight: 10, fontWeight: 'normal' }}>{alphaArr[index]}.</span>
																		<span className="inputLable content-justify preWrap" >
																			<label for={"ans" + props?.question?.questionId + "a" + index} >
																				{(myRow.responseText && myRow.responseText.length > 0) ?
																					<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.responseText.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
																					: null
																				}
																			</label>
																		</span>
																	</p>
																))
																: props?.question?.questionType == 'Integer Type' ?
																	<div><br/>{
																		props?.question?.responseChoice?.map((myRow, index) => (
																			<span style={{marginRight:15}}  key={'atdit' + index} >
																				<span className="inputSpan" >{alphaArr[index]}.<input style={{marginLeft:-1}} value={myRow.responseId} type="radio" id={"ans" + props?.question?.questionId + "a" + index} name={"ans" + props?.question?.questionId} className="inputRadio" checked={props?.question?.correctResponse===myRow.responseId?true:false} /> <span style={{marginLeft:-9}} >{myRow.responseText}</span></span>
																				{/* <span style={{marginLeft:-6}} className="inputLableIT"></span> */}
																				<input type="hidden" id={"hidetxtans" + props?.question?.questionId + "a" + index} />
																			</span>
																		))}
																	</div>
																	: (props?.question?.questionType == 'Fill In Blank' || props?.question?.questionType == 'Fill in Blank') ?
																		<table><tr>
																			<td></td>
																		</tr></table>
																		: props?.question?.responseChoice?.map((myRow, index) => (
																			<p key={'qkey' + index} id={'qmrid' + index}  >
																				<span className="inputSpan" ><input value={myRow.responseId} type="radio" id={"ans" + props?.question?.questionId + "a" + index} name={"ans" + props?.question?.questionId} className="inputRadio" checked={props?.question?.correctResponse===myRow.responseId?true:false} /></span>
																				<span className="inputLable" style={{ marginRight: 10, fontWeight: 'normal' }}>{alphaArr[index]}.</span>
																				<span className="inputLable content-justify preWrap" >
																					<label for={"ans" + props?.question?.questionId + "a" + index} >
																						{(myRow.responseText && myRow.responseText.length > 0) ?
																							<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.responseText.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
																							: null
																						}
																					</label>
																				</span>
																				<input type="hidden" id={"hidetxtans" + props?.question?.questionId + "a" + index} />
																			</p>
																		))
											}
										</div>
										
										{(props?.question?.questionType !== 'MR Matching Type' && props?.question?.correctResponse)?
										<p>
											<b style={{color:'#0000FF'}} >Correct Answer:</b>	{props?.question?.correctResponse}
										</p>
										:null}

										{props?.question?.explanations?
										<p>
											<b style={{color:'#0000FF'}}>Explanation:</b>	
											<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: props?.question?.explanations.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>
										</p>
										:null}

									</Grid>
								</Grid>
							</Box>


    </>
  );

});

export default CustomizedDialogs;